import { makeAutoObservable } from "mobx"
import DraftShareActionDraft from "./DraftShareActionDraft"

export default class DraftShareAction {

  constructor(action = {}) {
    this.id = action.id
    this.name = action.name
    this.action_type = action.action_type
    this.provider = action.provider
    this.username = action.username
    this.influencer_id = action.influencer_id
    this.influencer_name = action.influencer_name
    this.action_draft = action.action_draft ? new DraftShareActionDraft(action.action_draft) : null

    makeAutoObservable(this)
  }
}
